function handle(error) {
    switch (error.response.status) {
        case 404:
            if (error.response.data.message !== undefined && error.response.data.message === 'token_expired') {
                return 'Token expired, please request password reset link again.';
            }
            if (error.response.data.message !== undefined && (error.response.data.message === 'token_invalid' || error.response.data.message === 'token_absent')) {
                return 'Problem with your password reset token.';
            }
            if (error.response.data.message !== undefined && error.response.data.message === 'unknown_user') {
                return 'We can\'t find a user with that e-mail address.';
            }
            break;
        case 422:
            if (error.response.data.message !== undefined && error.response.data.message === 'email_token_dont_match') {
                return 'Please check if you entered the right email.';
            }
            break;
    }

    return null;
}

export const errorHandler = {
    handle,
};
